import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const CallOutgoingFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M12.49 21.67c-2.3 0-4.67-1.39-7.05-4.14-2.41-2.77-3.46-5.33-3.11-7.62.29-1.94 1.49-3 1.99-3.37l.43-.38c.45-.39.92-.55 1.4-.48.8.12 1.37.86 1.78 1.49l.38.6c.36.56 1.44 2.26-.04 3.55l-.53.46c-.06.05-.14.11-.23.17-.24.16-.35.25-.38.43-.03.22.05.91 1.4 2.46 1.35 1.55 2.02 1.73 2.25 1.73.17 0 .28-.1.47-.31.07-.08.14-.15.2-.2l.52-.46c1.49-1.29 3.02.03 3.52.46l.53.46c.57.49 1.23 1.15 1.23 1.97 0 .49-.22.93-.67 1.32l-.47.41c-.39.41-1.6 1.44-3.57 1.46h-.06l.01-.01Z" />
      <Path d="M11.02 12.96c.33.33.87.33 1.2 0l4.84-4.84v1.04a.85.85 0 1 0 1.7 0V6.01a.85.85 0 0 0-.85-.85h-3.09a.85.85 0 1 0 0 1.7h1.09l-4.89 4.89c-.33.33-.33.87 0 1.2v.01Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default CallOutgoingFilled
